import { utils } from 'utils';
import { reportErrorToDataDog } from '../../../utils/datadog';

const { dimension } = utils.getEnv();

export const redirectToHqIfNeeded = accessToken => {
  const isAppDimension = dimension === 'app';
  const hasClaims = Boolean(accessToken?.claims);
  const missingAccountId = !accessToken?.claims?.accountId;

  if (isAppDimension && hasClaims && missingAccountId) {
    const hqOrigin = window.location.origin.replace('app', 'hq');
    window.location.replace(`${hqOrigin}/auth/session-handler`);
    return true;
  }
  return false;
};

export const sanitizeRef = ref => {
  if (!ref) return '/';

  try {
    const parsed = new URL(ref, window.location.origin);
    if (parsed.hostname !== window.location.hostname) {
      console.error(`Blocked redirect to external host: ${parsed.hostname}`);
      return '/';
    }
    return parsed.pathname + parsed.search + parsed.hash;
  } catch {
    return '/';
  }
};

export const getRedirectUrl = () => {
  const ref = window.sessionStorage.getItem('ref');
  const isActivationFlow = window.sessionStorage.getItem('isActivationFlow');

  try {
    const safePath = sanitizeRef(ref);
    const url = new URL(safePath, window.location.origin);

    if (isActivationFlow) {
      url.searchParams.append('activation', isActivationFlow);
    }

    return url.toString();
  } catch (error) {
    reportErrorToDataDog('Failed to get redirect URL', {
      error,
      errorLocation: 'redirectService.getRedirectUrl',
    });
    console.error('Failed to parse redirect URL:', error);
  }

  return '/';
};

export const completeLoginAndRedirect = () => {
  const redirectUrl = getRedirectUrl();
  window.sessionStorage.clear();
  window.location.replace(redirectUrl);
};
